import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';

import {
  RewardsSectionHeader,
  RewardsTitle,
  RewardsDescription,
  CardsWrapper,
  CardBlock,
  RewardsCardTitle,
  RewardsCardDescription,
  ImageWrapper,
  TableLeftBgWrapper,
  TableRightBgWrapper,
} from './styles';

import { fieldHasContent } from '@/src/domains/prismic/helpers';

export function RewardsSlice({ data }) {
  const rewardsData = data?.body?.find(({ sliceType }) => sliceType === 'why_remote');

  const { title: rewardTitle, description: rewardDescription } = rewardsData.primary;

  const { fields } = rewardsData;

  return (
    <>
      <RewardsSectionHeader>
        {fieldHasContent(rewardTitle) && (
          <RewardsTitle>
            <PrismicRichText field={rewardTitle} />
          </RewardsTitle>
        )}
        {fieldHasContent(rewardDescription) && (
          <RewardsDescription>
            <PrismicRichText field={rewardDescription} />
          </RewardsDescription>
        )}
      </RewardsSectionHeader>
      <CardsWrapper>
        {fields.map(({ icon, heading, description: cardDescription }, index) => (
          <CardBlock key={index}>
            {icon && (
              <ImageWrapper>
                <Image
                  src={icon.url}
                  alt={icon.alt || ''}
                  width={icon.dimensions.width}
                  height={icon.dimensions.height}
                  quality="100"
                />
              </ImageWrapper>
            )}
            {fieldHasContent(heading) && (
              <RewardsCardTitle>
                <PrismicRichText field={heading} />
              </RewardsCardTitle>
            )}
            {fieldHasContent(cardDescription) && (
              <RewardsCardDescription>
                <PrismicRichText field={cardDescription} />
              </RewardsCardDescription>
            )}
          </CardBlock>
        ))}
      </CardsWrapper>
      <TableLeftBgWrapper />
      <TableRightBgWrapper />
    </>
  );
}
